import { View } from 'react-native'
import { COLORS, RADIUS } from '@/lib/brand'
import { encodeQrMatrix } from '@/lib/utils/qr-matrix'

interface HandoverQrProps {
  payload: string
  size?: number
  testID?: string
}

export function HandoverQr({
  payload,
  size = 168,
  testID = 'handover-presence.qr',
}: HandoverQrProps) {
  const matrix = encodeQrMatrix(payload)
  const cell = size / matrix.length

  return (
    <View
      testID={testID}
      accessibilityRole="image"
      style={{
        width: size,
        height: size,
        alignSelf: 'center',
        backgroundColor: COLORS.white,
        borderRadius: RADIUS.md,
        overflow: 'hidden',
      }}
    >
      {matrix.map((row, rowIndex) => (
        <View key={rowIndex} style={{ flexDirection: 'row' }}>
          {row.map((dark, colIndex) => (
            <View
              key={colIndex}
              style={{
                width: cell,
                height: cell,
                backgroundColor: dark ? COLORS.black : COLORS.white,
              }}
            />
          ))}
        </View>
      ))}
    </View>
  )
}
